
import controlPanelSharedStyle from "../../../Common/controlPanelSharedStyle";
import ChkIcon from '../../../../../resources/common/chk.svg';
import ChkOnIcon from '../../../../../resources/common/chk_on.svg';


const CommonStyle = `
  .jw-state-idle .jw-controls {
    background: rgba(0, 0, 0, 0) !important;
  }
  body{overflow:auto !important}
  html,
    body {
      height:100%;
      position: relative;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      vertical-align: baseline;
    }
    .swiper-pagination {
      position: absolute;
      text-align: center;
      transition: 300ms opacity;
      transform: translate3d(0, 0, 0);
      z-index: 10;
    }
    .swiper-container-horizontal
      > .swiper-pagination-bullets
      .swiper-pagination-bullet {
      margin: 0 4px;
    }
    .swiper-pagination-clickable .swiper-pagination-bullet {
      cursor: pointer;
    }
    .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 50%;
      background: #000;
      opacity: 0.2;
    }
    .content-area {
      height:100%;
      box-sizing: border-box;
      margin-bottom:100px;
    }
    .livebtn {
      position: relative;
      display: inline-block;
      width: 57px;
      height: 24px;
      text-align: center;
      background: #fff;
      border: 1px solid #723ec6;
      border-radius: 12px;
      box-sizing: border-box;
      margin-right:6px;

    }
    .livebtn small {
      display: inline-block;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: inline-block;
      color: #723ec6;
      font-size: 12px;
      font-weight: 400;
    }
    
    .ondemandbtn {
      position: relative;
      display: inline-block;
      width: 96px;
      text-align: center;
      color: #94ad51;
      font-size: 12px;
      height: 24px;
      line-height: 24px;
      background: #fff;
      border: 1px solid #94ad51;
      border-radius: 12px;
      box-sizing: border-box;
      margin-right:6px;
    }
    .ondemandbtn small {
      display: inline-block;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: inline-block;
      color: #94ad51;
      font-size: 10px;
      line-height: 1.6;
      font-weight: 400;
    }
    .basic_btn {
      width: 160px;
      height: 60px;
      line-height: 60px;
      background: #6a6af8;
      border-radius: 4px;
      color: #fff;
      font-size: 15px;
    }
  /*============어드민페이지===========*/
    /*====양쪽 사이드바====*/
    
    .admin_console {
      position: absolute;
      top: 250px;
      background: #3e3e46;
      box-sizing: border-box;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      transition: all 0.3s;
      z-index: 999;
    }
    .left_console {
      width: 300px;
      left: 0;
      border-radius: 0 8px 8px 0;
      height: 620px;
      overflow: hidden;
    }
    .right_console {
      width: 260px;
      right: 0;
      border-radius: 8px 0 0 8px;
      height: 220px;
      overflow: hidden;
    }
    
    /*=====lest_console========*/
    .left_console.on .text_container_top,
    .left_console.on .text_container_content {
      display: none;
    }
    .left_console .left_console_folding {
      display: none;
    }
    .left_console.on .left_console_folding {
      display: block;
    }
    .left_console.on {
      width: 50px;
      height: 220px;
      padding: 0;
    }
    .left_console.on .left_console_folding button {
      position: relative;
      display: block;
      width: 50px;
      height: 220px;
    }
    .left_console.on .left_console_folding button .arrow_div{
      position: absolute;
      top: 0;
      left: 0;
      width: 50px;
      height: 50px;
      text-align: center;
    }
    .left_console.on .left_console_folding button .number_div{
      height: calc(100% - 50px);
      width: 50px;
      margin-top: 50px;
    }
    .left_console.on .left_console_folding button img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%) rotate(180deg);
    }
    .left_console.on .left_console_folding h2 {
      display: inline-block;
      font-size: 15px;
      font-weight: 900;
      color: #fff;
      width: 100%;
      height: auto;
      position: absolute;
      top: 50%;
      left:0;
      transform: rotate(-90deg);
      white-space:nowrap;
    }
    
    
    .text_container_top {
      position: relative;
      display:flex;
      background: #3b3b3f;
      height: 50px;
      text-align: center;
    }
    .text_container_top:after {
      content: "";
      clear: both;
      display: block;
    }
    .text_container_top h2 {
      float: left;
      width: calc(100% - 50px);
      margin: 0px;
      font-size: 15px;
      color: #fff;
      line-height: 50px;
      font-weight: 900;
    }
    #firstB {
      position: relative;
      float: left;
      width: 50px;
      height: 50px;
      line-height: 50px;
      cursor: pointer;
      background: #3b3b3f;
      border: 0;
      outline: none;
      padding: 0;
      appearance: none;
    }
    #firstB img,
    #prevB img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    #prevB {
      position: absolute;
      top: 0;
      left: 50px;
      width: 50px;
      height: 50px;
      line-height: 50px;
      cursor: pointer;
      background: #3b3b3f;
      border: 0;
      outline: none;
      padding: 0;
      appearance: none;
    }
    .text_container_content{
      position:relative;
      height: calc(100% - 50px);
    }
    .text_container_content:after {
      content: "";
      clear: both;
      display: block;
    }
    .control_fix_div{
      position: absolute;
      bottom: 0;
      right: 0;
      padding: 14px;
      border-top: 1px solid #1f1f24;
      width: 100%;
      text-align: right;
    }
    .control_fix_div input{display:none;}
    .control_fix_div label{
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    .control_fix_div input + label span{
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 4px;
      box-sizing: border-box;
      background: url(${ChkIcon}) no-repeat;
      background-size:cover;
    }
    .control_fix_div input:checked + label span{
      background: url(${ChkOnIcon}) no-repeat;
      background-size:cover;
    }
    .control_list li {border-bottom:1px solid #1f1f24;}
    .control_list li img{opacity:0.3;}
    .control_list li.on img{opacity:1;}
    .control_list li.on a {
      background: #000;
    }

    
    .control_list li.on a img {
      opacity: 1;
    }
    
    .control_list a {
      display: flex;
      align-items: center;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #fff !important;
      background: #2e2e32;
      padding: 15px;
      box-sizing: border-box;
      cursor: pointer;
    }
    .control_list a span {
      font-size: 15px;
      font-weight: bold;
      display: inline-block;
      margin-left: 15px;
    }
    .control_list a.selected {
      background: #27272b;
    }
    .control_list a.selected img {
      opacity: 1;
    }
    .control_list.on {
      float: left;
      width: 50px;
    }
    .control_list.on span {
      display: none;
    }
    .control_list.on .control_list li:last-child {
      border-bottom: 0;
    }
    
    .control_content {
      position: relative;
      float: left;
      width: calc(100% - 50px);
      background: #000;
      height: 100%;
      padding:10px;
    }
    .control_content.none {
      display: none;
    }
    .control_content .top_title{margin-bottom:6px;}
    .control_content .top_title span {
      font-size: 12px;
      padding: 5px 0px 0px 10px;
      display: block;
      color: #5e5e61;
    }

    .control_content_list{margin-bottom:15px;}
    .control_content_list li{
      border-radius: 6px;
      padding: 10px;
      background:#1c1c1d;
      margin-bottom:6px;
    }
    .control_content_list li:last-child{
      margin-bottom:0;
    }
    .control_content_list a{display:block; margin-bottom:14px; cursor:pointer;}
    .control_content_list a span {
      font-size: 12px;
      color: #fff;
      line-height: 1.43;
      display:-webkit-box;
      -webkit-line-clamp:2;
      -webkit-box-orient:vertical;
      overflow:hidden;
    }
    .control_content_list .control_content_list_tool{display:flex; justify-content:flex-end; align-items:center;}
    .control_content_list .control_content_list_tool > div {display:flex; align-items:center;}
    .control_content_list .control_content_list_tool > div span{
      display:block;
      font-size: 11px;
      font-weight: 500;
      line-height: 11px;
      color: #5e5e61;
      margin-right:4px;
    }
    .control_content_list .control_content_list_tool label.switch{margin-right:10px;}
    /* 토글 체크박스 */
    label.switch {
        position: relative;
        width: 34px;
        height: 18px;
        border-radius: 14px;
        background: #202026;
        cursor: pointer;
    }
    label.switch input[type='checkbox'] {
        display:none;}
    label.switch span {
        position: relative;
        width: 100%;
        height: 100%;
        display: inline-block;
    }
    label.switch span::before {
        content: '';
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #999999;
        border-radius: 14px; }
        label.switch span::after {
        content: '';
        position: absolute;
        display: block;
        width: 12px;
        height: 12px;
        background-color: #fff;
        border-radius: 50%;
        top: 50%;
        left: 4px;
        transform:translateY(-50%);
        transition: left .3s ease;
        box-shadow: 0 2px 4px 0 rgb(90 90 90 / 50%);
    }
    label.switch input:checked ~ span::before {
        border: 1px solid #7758fa;
        background-color: #7758fa; }
    label.switch input:checked ~ span::after {
        left: 18px; }
    .control_content_list .control_content_list_tool .on_off_exporsure{cursor:auto;}
    .control_content_list .control_content_list_tool .on_off_exporsure strong{
      display: block;
      padding: 1px 10px;
      font-size: 8px;
      font-weight: bold;
      text-align: left;
      color: #7758fa;
      border-radius: 14px;
      border: solid 1px #7758fa;
    }
    .control_content_list .control_content_list_tool .on_off_exporsure strong.off{
      color: #5e5e61;
      border: solid 1px #5e5e61;
    }



    .control_content_detail {
      position: relative;
      float: left;
      width: calc(100% - 50px);
      background: #000;
      height: 100%;
      padding:10px;
      z-index: 999;
    }
    .control_content_detail > div{
      border-radius: 6px;
      background-color: #1c1c1d;
      margin-bottom:6px;
    }
    .control_content_detail > div:first-child{padding:10px;}
    .control_content_detail > div h4{
      font-size: 12px;
      line-height: 1.5;
      color: #fff;
      display:-webkit-box;
      -webkit-line-clamp:2;
      -webkit-box-orient:vertical;
      overflow:hidden;
    }
    .control_content_detail > div li {
      display:flex;
      align-items:center;
      justify-content:space-between;
      padding:10px;
      border-bottom: 1px solid #000;
    }

    .control_content_detail > div li:last-child {
      border-bottom: 0;
      cursor:pointer;
    }
    .control_content_detail > div li div{height:18px;}
    .control_content_detail > div li div a{
      display: block;
      width: 18px;
      height: 18px;
      text-align: center;
    }
    .control_content_detail > div li div span{
      font-size: 11px;
      font-weight: 500;
      line-height: 1.82;
      color: #fff;
    }
    .control_content_detail > div li h5{
      font-size: 12px;
      font-weight: 500;
      text-align: left;
      color: #5e5e61;
    }
    
    .control_content_detail .connect_way_div_inner{
      display:flex;
      justify-content:flex-end;
      align-items:center;
    }
    .control_content_detail .connect_way_div input {
      display: none;
    }
    .control_content_detail .connect_way_div input[type="radio"] + label span {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 5px;
      box-sizing: border-box;
      background: url("https://cdn.onoffevent.com/common/form_radio_off.svg");
      cursor:pointer;
    }
    .control_content_detail .connect_way_div input[type="radio"]:checked + label span {
      background: url("https://cdn.onoffevent.com/common/form_radio_on.svg");
      cursor:pointer;
    }
    .control_content_detail .connect_way_div label {
      display: flex;
      align-items: center;
      font-size: 11px;
      color: #fff;
      margin-right: 10px;
    }
    .control_content_detail .connect_way_div label:last-child {
      margin-right: 0;
    }
    .control_content_detail .progress_complete input {
      display: none;
    }
    .control_content_detail .progress_complete input + label {
      display: flex;
      align-items: center;
      font-size: 11px;
      font-weight:500;
      color:#fff;
      cursor:pointer;
    }
    .control_content_detail .progress_complete input + label span {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 4px;
      border-radius: 4px;
      box-sizing: border-box;
      background: url("${ChkIcon}") no-repeat;
      background-size:cover;
      cursor:pointer;
    }
    .control_content_detail .progress_complete input:checked + label span {
      background: url("${ChkOnIcon}") no-repeat;
      background-size:cover;
      cursor:pointer;
    }

    .control_content_detail > div li.survey_edit h5{
      font-size: 12px;
      font-weight: 500;
      color: #7758fa;
    }

    ${controlPanelSharedStyle}
    
    .exit_content{
      padding:10px;
      border-radius: 6px;
      background-color: #1c1c1d;
    }
    .exit_content ul li{display:flex; align-items:center; justify-content:space-between;}
    .exit_content ul li div{height:18px;}
    .exit_content ul li h5{
      font-size: 12px;
      font-weight: 500;
      text-align: left;
      color: #5e5e61;
    }
    /*===========right_console=============*/
    .admin_console_top {
      display: flex;
      justify-content: left;
      align-items: center;
      background: #3b3b3f;
    }
    .admin_console_top h2 {
      font-size: 15px;
      color: #fff;
      margin: 0 auto;
    }
    .admin_console_top button {
      width: 50px;
      height: 50px;
    }
    .right_console button {
      width: 50px;
      height: 50px;
      transform: rotate(180deg);
      transition: all 0.3s;
    }
    .right_console.on button {
      transform: rotate(0deg);
    }
    .right_console_content {
      padding: 20px 20px 10px 20px;
    }
    .right_console_content p {
      font-size: 15px;
      color: #fff;
      font-weight: normal;
      margin-bottom: 5px;
    }
    .right_console_content span {
      font-size: 40px;
      font-weight: 900;
      color: #9898fc;
      line-height: 1.6;
      cursor:pointer;
      text-decoration:underline;
    }
    .right_console .right_console_folding {
      display: none;
    }
    .right_console.on {
      width: 50px;
      height: 220px;
      padding: 0;
    }
    .right_console.on .right_console_folding {
      display: block;
      inline-size: inherit;
      box-sizing: border-box;
      font-size:0;
    }
    .right_console .right_console_folding button {
      position: relative;
      height: 220px;
      z-index: 999999;
    }
    .right_console .right_console_folding button .arrow_div{
      position: absolute;
      top: 0;
      left: 50%;
      width: 50px;
      height: 50px;
      transform: translateX(-50%);
    }
    .right_console .right_console_folding button .number_div{
      position:relative;
      height: calc(100% - 50px);
      margin-top: 50px;
    }
    .right_console .right_console_folding button img {
      position: absolute;
      top: 15px;
      left: 50%;
      transform: translate(-50%);
    }
    .right_console.on .right_console_folding h2 {
      font-size: 15px;
      font-weight: 900;
      display: inline-block;
      color: #fff;
      position: absolute;
      bottom: 35%;
      left: 0;
      width: 50px;
      transform: rotate(-90deg);
      white-space: nowrap;
    }
    .right_console.on .right_console_folding span {
      font-size: 16px;
      display: inline-block;
      font-weight: 900;
      text-align: left;
      color: #9898fc;
      transform: rotate(-90deg);
      width: 46px;
      position: absolute;
      top: 14%;
      left: 0;
      text-align:center;
    }
    .right_console.on .admin_console_top,
    .right_console.on .right_console_content {
      display: none;
    }
    .right_console.on .admin_console_top h2 {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%) rotate(180deg);
      writing-mode: vertical-lr;
    }
`

export default CommonStyle;
